import { FONT_FAMILY_BROWN_WITH_FALLBACKS } from '../../../../fonts';

export const TEXT_TRACK_TEXT_FEEDBACK_STYLE = {
  default: {
    fontSize: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2px',
    fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS,
    fontWeight: 700,
    iconSize: 14
  },
  small: {
    fontSize: '12px',
    iconSize: 16
  },
  medium: {
    fontSize: '16px',
    iconSize: 20
  },
  'large+extraLarge': {
    fontSize: '18px',
    iconSize: 22
  }
};

export const TEXT_TRACK_TEXT_DETAIL_STYLE = {
  default: {
    fontSize: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2px',
    fontFamily: FONT_FAMILY_BROWN_WITH_FALLBACKS,
    fontWeight: 400,
    iconSize: 12
  },
  small: {
    fontSize: '10px',
    iconSize: 14
  },
  medium: {
    fontSize: '14px',
    iconSize: 16
  },
  'large+extraLarge': {
    fontSize: '16px',
    iconSize: 18
  }
};

export const FEEDBACK_STYLE_TEXT_TRACK = {
  default: {
    display: 'flex',
    gap: '4px',
    alignItems: 'flex-start',
    flexDirection: 'column',
    padding: '4px 8px',
    width: 'max-content',
    border: '1px solid #7A9CEB',
    borderRadius: '8px'
  },
  small: {
    padding: '6px 8px'
  },
  medium: {
    padding: '8px 12px',
    border: '1.5px solid #7A9CEB'
  },
  'large+extraLarge': {
    padding: '8px 12px',
    border: '1.5px solid #7A9CEB'
  }
};
